<ax-text-box>
    <ax-button>
        <i class="far fa-clock"></i>
    </ax-button>
</ax-text-box>